import React from "react"

interface SkeletonProps {
    data: any
}

export default function Skeleton({ data }: SkeletonProps) {
    const skeleton =
        "w-full h-90 animate-pulseColor rounded bg-neutral-100 dark:bg-neutral-700"

    return (
        <div className="flex h-[1000px] w-full flex-col gap-30">
            <div
                className={
                    "animate-pulseColor h-100 w-400 rounded bg-neutral-100 dark:bg-neutral-700"
                }
            />
            <div className={skeleton} />
            <div className={skeleton} />
            <div className={skeleton} />
            <div className={skeleton} />
            <div className={skeleton} />
            <div className={skeleton} />
            <div className={skeleton} />
            <div className={skeleton} />
            <div className={skeleton} />
            <div className={skeleton} />
        </div>
    )
}
